export enum Fiability {
  LOW,
  MEDIUM,
  HIGH,
}
